<template>
    <div class="covid-tab">
        <div class="tabulation-title" :style="'color:' + titlesColor">
            <h5>
                {{ index }}. Dispositions sanitaires
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <p>
                Détaillez ci-dessous en quelques phrases les services et prestations mis en place (modalités de réservation, nombre de personnes maximal dans un groupe/en terrasse, procédures sanitaires, équipement à disposition...).
                Ces informations seront largement diffusées vers vos visiteurs via nos supports de communication.
            </p>

            <form-component-loader :fields="tabulationFields"></form-component-loader>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapMutations, mapState} from "vuex"
    import FormComponentLoader from "../FormComponentLoader.vue"

    export default {
        name: "Covid",
        components: {FormComponentLoader},
        props: ['index'],
        computed: {
            ...mapState('webFormStyle', ['titlesColor']),
            ...mapGetters('web_form', ['getFieldsFromTabulation']),
            tabulationFields() {
                return this.getFieldsFromTabulation('COVID').sort((a, b) => a.order - b.order)
            }
        }
    }
</script>
